import { render } from "./CreateAnnouncement.vue?vue&type=template&id=77cb26f2&scoped=true"
import script from "./CreateAnnouncement.vue?vue&type=script&lang=js"
export * from "./CreateAnnouncement.vue?vue&type=script&lang=js"

import "./CreateAnnouncement.vue?vue&type=style&index=0&id=77cb26f2&lang=scss&scoped=true"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cb26f2"]])

export default __exports__